<template>
  <div  class="animated fadeIn">
    <b-card>
      <template slot="header">
        <i class='fa fa-align-justify'></i> UWSS Fetch Log
      </template>

      <b-row>
        <b-col class="mb-3">
          <b-input-group style="width : 45%" size="sm" class="float-right">
            <b-input-group-prepend>
              <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-refresh"></i></b-btn>
              <b-btn variant="outline-secondary" @click="reset()"><i class="fa fa-remove"></i></b-btn>
              <b-dropdown :text="so.skt || 'Search'" size="sm" variant="outline-secondary">
                <b-dropdown-item size="sm" @click="so.sk='fetch_addr';so.skt='IPAddress'">IPAddress</b-dropdown-item>
              </b-dropdown>
            </b-input-group-prepend>
            <b-input v-model="so.sv" @keyup.enter="refresh()"></b-input>
            <b-input-group-append>
              <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-search"></i></b-btn>
              <!-- <b-btn variant="outline-secondary"><i class="fa fa-search-plus"></i></b-btn> -->
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>

      <b-table hover striped small responsive="sm" foot-clone ref="_list" show-empty empty-text="not found"
        :items="getItems" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage">
        <template #cell(id)="row">{{row.item.id}}</template>
        <template #cell(is_valid)="row">
          <b-badge v-if="row.item.is_valid" pill variant="success">5</b-badge>
          <span v-else>
            -
          </span>
        </template>
        <template #cell(addr)="row">{{row.item.fetch_addr}}</template>
        <template #cell(count)="row">{{row.item.fetch_count}}</template>
        <template #cell(description)="row">{{row.item.description}}</template>
        <template #cell(created_at)="row">{{row.item.created_at | datetime}}</template>
      </b-table>

      <b-row>
        <b-col class="mt-1 d-flex justify-content-center">
          <b-pagination size="sm" :total-rows="rowCount" :per-page="so.perPage" v-model="so.currentPage" prev-text="Prev" next-text="Next"/>
        </b-col>
      </b-row>
    </b-card>
    <router-view @refresh="refresh()"></router-view>
  </div>
</template>

<script>
import { api } from '@/f1/service';

const default_opt = () => ({
  perPage: 25,
  currentPage: 1, totalRows: 0,
  sk: '', sv: '', skt: '', opt : {}, adv: false
});

export default {
  data: () => ({ so : default_opt() }),
  computed: {
    rowCount() { return this.so.totalRows || 0; },
    startRow() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    fields() {
      return [
        { key: 'id', label: 'No', sortable: true, thStyle: 'width: 10%' },
        { key: 'is_valid', label: 'Result' },
        { key: 'fetch_addr', label: 'IpAddress' },
        { key: 'fetch_count', label: 'Count' },
        { key: 'type', label: 'Type', sortable: true },
        { key: 'description', label: 'description', sortable: true },
        { key: 'created_at', label: 'Created At', sortable: true },
      ];
    },
  },
  methods: {
    reset() { this.so = default_opt(); this.refresh(); },
    refresh() { this.$refs._list.refresh(); },
    getRowCount () { return this.so.totalRows || 0; },
    getItems(ctx) { return this.load(ctx); },
    async load(ctx = {}) {
      let so = {
        ok : ctx.sortBy,
        od : ctx.sortDesc ? 'd' : 'a',
        pg : ctx.currentPage || this.so.currentPage || 1,
        pc : ctx.perPage || this.so.perPage || 10,
        sk : this.so.sk || 'fetch_addr',
        sv : this.so.sv,
        opt: this.so.adv ? Object.assign({}, this.so.opt) : {}
      }
      // Build all
      var search = { limit: so.pc, offset: (so.pg - 1) * so.pc, and: [], or: [], sort: [] }
      // order
      if(so.ok) { search.sort.push({name: so.ok, op: so.od == 'd' && 'desc' }); }
      // search
      if(so.sk && so.sv) {
        //search 모드에서 검색할때
        if(!so.ok){
          search.sort.push({name: so.sk, op: so.od == 'd' && 'desc' });
        }
        search.or.push({name: so.sk, value: `%${so.sv}%`, op: 'like'});
      }

      try { let rs = await api.uwss.log_fetch.list(search); this.so.totalRows = rs.count; return rs.result; }
      catch(e) { this.$toastr.e(e.data || e); }
    },
    // detail(item) {
    //   this.$router.push(`/site/${item.id}`);
    // },
  },
  created() { },
  destroyed() { },
  mounted() { },
}
</script>
